<template>
  <div v-if="loading" class="loading">Aguarde ...</div>
  <div v-else class="container">
    <div class="text-left">
      <h3>
        <router-link to="/mensagens">Mensagens</router-link> » Selecione os clientes
        <button v-if="!loading" @click.prevent="saveList()" class="btn btn-success pull-right">Salvar</button>
        <button v-else class="btn btn-muted pull-right">Aguarde...</button>
      </h3>
    </div>
    <div class="col-sm-12 text-left">
      <b>Mensagem</b> #{{msg.cod}}. Visível de <b>{{formatData(msg.dt_inicio)}}</b> até <b>{{formatData(msg.dt_fim)}}</b>
    </div>
    <div class="col-sm-12 msgdisplay">
      <div v-html="msg.msg"></div>
    </div>
    <table>
      <tr>
        <td>#</td>
        <td>PSWEB chave CLIENTE pos.16</td>
        <td>Qtd.</td>
      </tr>
      <tr v-for="chave in chaves" :class="chave.status? 'bg-primary' : ''">
        <td><input type="checkbox" v-model="chave.status"></td>
        <td>{{chave.cliente===''? 'Sem chave no HUB' : chave.cliente}}</td>
        <td>{{chave.qtd}}</td>
      </tr>
      <tr>
        <td>
          <input @click="selectAll()" ref="iptselectall" type="checkbox">
          <label v-if="!iptSelectBool" for="" class="control-form">Marcar Todos</label>
          <label v-else for="" class="control-form">Desmarcar Todos</label>
        </td>
        <td></td>
        <td></td>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'mensagemselect',
    data () {
      return {
        loading: false,
        iptSelectBool: false,
        msg: [],
        chaves: [],
        msglist: []
      }
    },
    methods: {
      loadMsg (params = '') {
        const url = './api/php/getmsg.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response)
            console.log(response.body)
            if (response.body.cod > 0) {
              this.msg = response.body
              this.loadMsgList()
            } else {
              console.log('Erro ao carregar a Mensagem.')
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      loadMsgList () {
        const url = './api/php/getmsglist.php'
        this.$http.post(url, JSON.stringify({'cod': this.msg.cod})).then(
          function (response) {
            console.log(response.body)
            if (response.body.status) {
              this.chaves = response.body.rows
            } else {
              this.chaves = []
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      save (params = '') {
        const url = './api/php/addmsglist.php'
        this.$http.post(url, JSON.stringify({'rows': this.msglist})).then(
          function (response) {
            console.log(response)
            if (response.body.status) {
              this.chaves = response.body.rows
            } else {
              this.chaves = []
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      saveList () {
        this.msglist = []
        const codmsg = this.msg.cod
        const atucodig = this.msg.atucodig
        const l = this.chaves.length
        let chave = ''
        var i = 0
        for (i; i < l; i++) {
          chave = this.chaves[i]
          if (chave.status) {
            this.msglist.push({'codmsg': codmsg, 'cliente': chave.cliente, 'atucodig': atucodig})
          }
        }
        this.save()
      },
      selectAll () {
        const bool = this.$refs.iptselectall.checked
        this.iptSelectBool = bool
        const l = this.chaves.length
        var i = 0
        for (i; i < l; i++) {
          this.chaves[i].status = bool
        }
      },
      formatData (date) {
        if (date.length > 0) {
          date = date.replace(/-/g, '').substring(0, 8)
          return date.substring(6, 8) + '/' + date.substring(4, 6) + '/' + date.substring(0, 4)
        }
      }
    },
    created: function () {
      const cod = this.$route.params.id
      this.loadMsg({'cod': cod})
    },
    watch: {
      '$route' (to, from) {
        const cod = this.$route.params.id
        this.loadMsg({'cod': cod})
      }
    }
  }
</script>

<style scoped>
    .container {
      width: 80vw;
      margin: auto;
    }
    table {
      font: 12px sans-serif;
      color: #333;
      border-collapse: collapse;
      outline: 2px solid #333;
      text-align: left;
      width: 100%;
    }
    table tr:not(.bg-primary) {
      background: #fcfcfc;
    }
    table tr:nth-child(2n+1):not(.bg-primary):not(':first-clild') {
      background: #f1f1f1;
    }
    table tr:hover:not(.bg-primary){
      background: #ccc;
    }
    table tr:first-child {
      background: #333;
      color: #fff;
      text-transform: uppercase;
    }
    table tr td {
      padding: 5px;
    }
    table tr td small {
      color: #777;
    }
    a.glyphicon {
      text-decoration: none;
    }
    div.msgdisplay {
      color: #333;
      border: 2px solid #FFF;
      outline: 2px solid #e9e9e9;
      background: #e9e9e9;
      padding: 10px;
      text-align: left;
      margin: 10px 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/MensagemSelect.vue